"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TypeCounter = _interopRequireDefault(require("./TypeCounter"));

var DefaultAssetCounts = function DefaultAssetCounts(_ref) {
  var assetCounts = _ref.assetCounts;
  var truck = assetCounts.truck,
      bus = assetCounts.bus,
      van = assetCounts.van,
      trailer = assetCounts.trailer,
      driver = assetCounts.driver;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'display-flex'
  }, /*#__PURE__*/_react.default.createElement(_TypeCounter.default, {
    icon: 'truck-baseline',
    value: truck
  }), /*#__PURE__*/_react.default.createElement(_TypeCounter.default, {
    icon: 'trailer-baseline',
    value: trailer
  }), /*#__PURE__*/_react.default.createElement(_TypeCounter.default, {
    icon: 'bus-baseline',
    value: bus
  }), /*#__PURE__*/_react.default.createElement(_TypeCounter.default, {
    icon: 'van-baseline',
    value: van
  }), /*#__PURE__*/_react.default.createElement(_TypeCounter.default, {
    icon: 'driver',
    value: driver
  }));
};

var TreeSummary = /*#__PURE__*/_react.default.memo(function (props) {
  var className = props.className,
      assetCounts = props.assetCounts,
      children = props.children;
  var classes = (0, _classnames.default)('TreeSummary', 'display-flex', 'align-items-center', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children || /*#__PURE__*/_react.default.createElement(DefaultAssetCounts, {
    assetCounts: assetCounts
  }));
});

TreeSummary.displayName = 'TreeSummary';
TreeSummary.defaultProps = {
  assetCounts: {},
  className: ''
};
TreeSummary.propTypes = {
  assetCounts: _propTypes.default.shape({
    truck: _propTypes.default.number,
    trailer: _propTypes.default.number,
    bus: _propTypes.default.number,
    van: _propTypes.default.number,
    driver: _propTypes.default.number
  }),
  className: _propTypes.default.string
};
var _default = TreeSummary;
exports.default = _default;